import { Sidebar, SidebarContent, SidebarFooter } from "@/components/ui/sidebar/sidebar";
import { SidebarProvider } from "@/components/ui/sidebar/sidebar-context";
import { SidebarComponentProps } from "./sidebar/types";
import { LogoutButton } from "./sidebar/LogoutButton";
import { AccessCodeVerificationDialog } from "./sidebar/AccessCodeVerificationDialog";
import { SidebarMenu } from "./sidebar/SidebarMenu";
import { useSidebarState } from "./sidebar/SidebarState";

export const SidebarComponent = ({ userType = "admin", isInventoryActive = false }: SidebarComponentProps) => {
  const {
    authorizedFeatures,
    visibleMenuItems,
    accessCodes,
    selectedMenuItem,
    isDialogOpen,
    filteredLinks,
    setIsDialogOpen,
    setSelectedMenuItem,
    handleEyeClick,
    toggleMenuItemVisibility,
    shouldShowEyeIcon,
    isFeatureVisible,
  } = useSidebarState(userType);

  return (
    <SidebarProvider>
      <Sidebar>
        <SidebarContent>
          <SidebarMenu
            links={filteredLinks}
            userType={userType}
            isInventoryActive={isInventoryActive}
            visibleMenuItems={visibleMenuItems}
            authorizedFeatures={authorizedFeatures}
            onEyeClick={handleEyeClick}
            shouldShowEyeIcon={shouldShowEyeIcon}
            isFeatureVisible={isFeatureVisible}
            accessCodes={accessCodes}
            selectedMenuItem={selectedMenuItem}
          />
        </SidebarContent>
        <SidebarFooter>
          <LogoutButton isInventoryActive={isInventoryActive} />
        </SidebarFooter>
      </Sidebar>
      <AccessCodeVerificationDialog
        isOpen={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
          setSelectedMenuItem(null);
        }}
        onVerify={() => {
          if (selectedMenuItem) {
            toggleMenuItemVisibility(selectedMenuItem);
          }
        }}
        expectedCode={selectedMenuItem ? accessCodes[(filteredLinks.find(l => l.name === selectedMenuItem) as any).feature] : undefined}
      />
    </SidebarProvider>
  );
};

export { SidebarComponent as Sidebar };